import mailIcon from "../../assets/design-revamp/mail-icon.svg";

const MailIcon = ({ style, onClick }) => {
  return (
    <>
      <div onClick={onClick}>
        <img
          className=""
          src={mailIcon}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default MailIcon;
